import React, { useState } from "react";
import { AnimatePresence } from "framer-motion";
import { Trophy } from "lucide-react";
import { TROPHIES, useTrophyCount } from "@/lib/trophies";
import { sfx } from "@/lib/sound";
import TrophyCabinet from "@/pages/idevra/TrophyCabinet";

export default function TrophyChip() {
  const [open, setOpen] = useState(false);
  const count = useTrophyCount();

  return (
    <>
      <button
        type="button"
        data-testid="trophy-chip-btn"
        title="Open the trophy cabinet"
        onClick={() => {
          sfx.clank();
          setOpen(true);
        }}
        className="iv-glass flex h-10 items-center gap-2 rounded-full px-3.5 text-[#475569] hover:text-[#0284C7] transition-colors"
      >
        <Trophy size={15} />
        <span className="f-orbitron text-[11px] font-bold">
          {count}/{TROPHIES.length}
        </span>
      </button>
      <AnimatePresence>{open && <TrophyCabinet onClose={() => setOpen(false)} />}</AnimatePresence>
    </>
  );
}
